<script>
import { mapState } from 'vuex'
import ReservationDetail from '@components/reservation-detail'
import Request from '@src/mixins/request'
import headers from '@src/data/headers.json'
import dropdown from '@src/data/dropdown.json'

export default {
  metaInfo: {
    title: 'Reservation',
    meta: [{ name: 'description', content: 'Reservation' }],
  },

  $_veeValidate: { validator: 'new' },

  components: { ReservationDetail },

  mixins: [Request],

  props: {
    countryList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      headers: headers.reservation,
      color: 'gold',
      item: {},
      dialog: false,
      items: [],
      form: {
        startDate: null,
        endDate: null,
        filter: {
          date: 'CHECK-IN',
          country: null,
          status: null,
        },
      },
      dropdown,
    }
  },

  computed: {
    ...mapState('app', {
      propertyId: (state) => state.currentProperty.id,
    }),
    tableHeaders() {
      const th = this.headers.slice(0)
      th.push({ text: 'Actions', sortable: false, align: 'right' })
      return th
    },
    countries() {
      const c = this.countryList.slice()
      c.unshift({ id: null, name: 'All' })
      return c
    },
  },

  watch: {
    dialog(val) {
      if (!val) {
        setTimeout(() => {
          this.item = {}
        }, 300)
      }
    },
  },

  methods: {
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchItems()
        }
      })
    },
    async fetchItems() {
      const data = Object.assign({ propertyId: this.propertyId }, this.form)

      this.items = await this.fetchData({
        url: this.endpoint.reservation.list,
        data,
      })
    },
    async showDetail(item) {
      this.item = await this.fetchData({
        url: this.endpoint.reservation.get,
        data: {
          propertyId: this.propertyId,
          id: item.id,
        },
      })
      this.dialog = true
    },
  },
}
</script>

<template>
  <BaseView title="Reservation" :color="color">
    <!-- Toolbar Extension -->
    <VContainer slot="toolbar-extension" class="px-0" grid-list-xl>
      <VLayout row wrap>
        <VFlex xs12 sm4>
          <VSelect
            v-model="form.filter.date"
            :items="dropdown.inventoryFilter"
            :color="color"
            label="By"
          />
        </VFlex>

        <VFlex xs12 sm4>
          <VSelect
            v-model="form.filter.status"
            :items="dropdown.inventoryStatus"
            :color="color"
            label="Status"
          />
        </VFlex>

        <VFlex xs12 sm4>
          <VAutocomplete
            v-model="form.filter.country"
            :items="countries"
            :color="color"
            item-text="name"
            item-value="id"
            label="Country"
          />
        </VFlex>

        <VFlex xs12 sm3>
          <BaseDatePicker
            ref="from"
            v-model="form.startDate"
            v-validate="'required|date_format:yyyy-MM-dd'"
            data-vv-name="from"
            :error-messages="errors.collect('from')"
            :color="color"
            label="From"
          />
        </VFlex>

        <VFlex xs12 sm3>
          <BaseDatePicker
            v-model="form.endDate"
            v-validate="'required|date_format:yyyy-MM-dd|after:from,true'"
            data-vv-name="to"
            :error-messages="errors.collect('to')"
            :color="color"
            label="To"
          />
        </VFlex>

        <VFlex xs12 sm2>
          <VBtn
            depressed
            :dark="!errors.any()"
            :disabled="errors.any()"
            :color="color"
            @click="onSubmit"
          >
            Search
          </VBtn>
        </VFlex>
      </VLayout>
    </VContainer>
    <!-- End of Toolbar Extension -->

    <VDataTable
      :headers="tableHeaders"
      :loading="loading ? color : false"
      :items="items"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="(header, index) in headers"
          :key="`${header.text}-${index}`"
          :class="{ 'text-xs-right': header.align && header.align === 'right' }"
          :style="{ width: header.witdh }"
        >
          {{ props.item[header.value] }}
        </td>
        <td class="text-xs-right">
          <!-- View Icon -->
          <VIcon small @click="showDetail(props.item)">
            remove_red_eye
          </VIcon>
          <!-- End of View Icon -->
        </td>
      </template>
    </VDataTable>

    <ReservationDetail v-model="dialog" :item="item" />
  </BaseView>
</template>
